import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { BtnClsNames, HomeBtnStyle } from "../config/btn_config";

export default function HomeButton({name,route}) {
  const navigate = useNavigate();
  return (
    <Button className={BtnClsNames} style={HomeBtnStyle} onClick={() => navigate(route ? route : "/")}>
      {name ? name : 'Home'}
    </Button>
  );
}